
import * as types from './mutations_types.js';

export default {
	update_areaOption: ({
		commit
	}, 
		data
	) => {
		return new Promise((resolve, reject) => {
			commit(types.update_areaOption, 
				data
			);
			resolve()
		});
	},

	update_scoreItem: ({
		commit
	}, 
		data
	) => {
		return new Promise((resolve, reject) => {
			commit(types.update_scoreItem, 
				data
			);
			resolve()
		});
  },
  

  update_device: ({
    commit
  },
    data
  ) => {
    return new Promise((resolve, reject) => {
      commit(types.update_device,
        data
      );
      resolve()
    });
  },


  update_isCollapse: ({
    commit
  },
    data
  ) => {
    return new Promise((resolve, reject) => {
      commit(types.update_isCollapse,
        data
      );
      resolve()
    });
  },

  
  update_cachedViews: ({
    commit
  },
    data
  ) => {
    return new Promise((resolve, reject) => {
      commit(types.update_cachedViews,
        data
      );
      resolve()
    });
  },




	
};